import { Box, Button } from "@mui/material"
import Controls from "../../components/controls/Controls"
import { Form, useForm } from "../../components/useForm"
import { FormEvent, useEffect } from "react";

type Props = {
  filters: any;
  onFindTrace: (values: any) => void
}

const Search = (props: Props) => {
  const { values, handleInputChange, setValues } = useForm({});
  const { filters, onFindTrace } = props;

  useEffect(() => {
    setValues(filters)
  }, [])

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onFindTrace(values)
  }
  return (
    <Box bgcolor="grey.100" padding={2} width={'100%'} >
      <Form onSubmit={onSubmit} display={"flex"}>
        <Controls.Input
          label="TraceId(X-Request-Id)"
          name="requestId"
          placeholder={"Enter request Id"}
          onChange={handleInputChange}
          size="small"
          value={values?.requestId || ''}
          sx={{width:"70%"}}
        />

        <Button type="submit" sx={{}} variant="contained">Find Traces</Button>
      </Form>
    </Box>
  )
}

export default Search